var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #00b0a9;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10501",
    "data-name": "Group 10501",
    transform: "translate(-175.5 -776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10500",
    "data-name": "Group 10500",
    transform: "translate(-26 470.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10491",
    "data-name": "Group 10491",
    transform: "translate(202 307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467",
    transform: "translate(15.158 2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    className: "cls-1",
    d: "M-21048.227-23995.092v-1.674",
    transform: "translate(21050.627 23996.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    className: "cls-1",
    d: "M-21048.227-23995.092v-1.674",
    transform: "translate(21048.227 23996.766)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10494",
    "data-name": "Group 10494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7385",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M7.566,14.778H2.222A2.222,2.222,0,0,1,0,12.556V10",
    transform: "translate(0 -7.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-2",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M20,14.778V12.222A2.222,2.222,0,0,0,17.778,10H2.222A2.222,2.222,0,0,0,0,12.222v2.556",
    transform: "translate(0 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-3",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M63.861,10v2.556a2.222,2.222,0,0,1-2.222,2.222H56.393",
    transform: "translate(-43.861 -7.778)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3090",
    "data-name": "Rectangle 3090",
    className: "cls-2",
    width: 3.244,
    height: 1.673,
    rx: 0.836,
    transform: "translate(2.4 2.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10493",
    "data-name": "Group 10493",
    transform: "translate(8.444 5.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    className: "cls-3",
    d: "M109.562,31.124a1.562,1.562,0,1,1,1.562-1.562A1.567,1.567,0,0,1,109.562,31.124Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3091",
    "data-name": "Rectangle 3091",
    className: "cls-2",
    width: 3.244,
    height: 1.673,
    rx: 0.836,
    transform: "translate(7.511 2.4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10492",
    "data-name": "Group 10492",
    transform: "translate(202 317.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10467-2",
    "data-name": "Group 10467",
    transform: "translate(15.158 2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7136-2",
    "data-name": "Path 7136",
    className: "cls-1",
    d: "M-21048.227-23995.092v-1.674",
    transform: "translate(21050.627 23996.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383-2",
    "data-name": "Path 7383",
    className: "cls-1",
    d: "M-21048.227-23995.092v-1.674",
    transform: "translate(21048.227 23996.766)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10494-2",
    "data-name": "Group 10494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-4",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M7.566,14.778H2.222A2.222,2.222,0,0,1,0,12.556V10",
    transform: "translate(0 -7.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-5",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M20,14.778V12.222A2.222,2.222,0,0,0,17.778,10H2.222A2.222,2.222,0,0,0,0,12.222v2.556",
    transform: "translate(0 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-6",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M63.861,10v2.556a2.222,2.222,0,0,1-2.222,2.222H56.393",
    transform: "translate(-43.861 -7.778)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3090-2",
    "data-name": "Rectangle 3090",
    className: "cls-2",
    width: 3.244,
    height: 1.673,
    rx: 0.836,
    transform: "translate(2.4 2.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10493-2",
    "data-name": "Group 10493",
    transform: "translate(8.444 5.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003-2",
    "data-name": "Path 7003",
    className: "cls-3",
    d: "M109.562,31.124a1.562,1.562,0,1,1,1.562-1.562A1.567,1.567,0,0,1,109.562,31.124Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3091-2",
    "data-name": "Rectangle 3091",
    className: "cls-2",
    width: 3.244,
    height: 1.673,
    rx: 0.836,
    transform: "translate(7.511 2.4)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3093",
    "data-name": "Rectangle 3093",
    className: "cls-4",
    width: 20,
    height: 20,
    transform: "translate(176 776)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBoxes);
export default __webpack_public_path__ + "static/media/totalBoxes.481492cfa85cfb5260160d09be22ed58.svg";
export { ForwardRef as ReactComponent };